import { CollectionMetadata } from '../types/Collection'

export const collectionTransformer = (
  collectionMetadata: CollectionMetadata
): CollectionMetadata => ({
  collectionTypes: collectionMetadata?.collectionTypes || [],
  count: collectionMetadata?.count || 0,
  createdAt: collectionMetadata?.createdAt || 0,
  description: collectionMetadata?.description || '',
  heroCaption: collectionMetadata?.heroCaption || '',
  heroImage: collectionMetadata?.heroImage || '',
  idUserCollection: collectionMetadata?.idUserCollection || 0,
  isAACollection: collectionMetadata?.isAACollection || false,
  isDeleted: collectionMetadata?.isDeleted || false,
  isPrivate: collectionMetadata?.isPrivate || false,
  isPrintsView: collectionMetadata?.isPrintsView || false,
  ownerAvatar: collectionMetadata?.ownerAvatar || '',
  ownerId: collectionMetadata?.ownerId || 0,
  ownerName: collectionMetadata?.ownerName || '',
  ownerTitle: collectionMetadata?.ownerTitle || '',
  slug: collectionMetadata?.slug || '',
  title: collectionMetadata?.title || '',
})
